import { Button } from "@/components/ui/button";

interface DownloadAppButtonProps {
  onClick?: () => void;
}

export function DownloadAppButton({ onClick }: DownloadAppButtonProps) {
  return (
    <Button
      variant="ghost"
      onClick={onClick}
      className="flex items-center gap-[px] h-auto px-0 py-0 hover:bg-transparent"
    >
      <div>
        <img
          src="./images/navbar/device-mobile.svg"
          alt="My Logo"
          width={40}
          height={29}
        />
      </div>

      <span className="text-[12px] font-lexend font-normal tracking-[-0.22px] leading-[14.40px] capitalize text-text-secondary whitespace-nowrap">
        download the <br /> auqli app
      </span>
    </Button>
  );
}
